<template>
    <section class="columns noprint">
        <div class="scfForm">
            <div class="campusForm">
                <div>
                    <div>
                        <fieldset class="scfSectionBorderAsFieldSet">
                            <div class="scfSectionContent">

                                <div class="scfSingleLineTextBorder">
                                    <label for="telefonP" class="scfSingleLineTextLabel">
                                        {{ getTranslation('camp_edu_TelP') }}
                                    </label>
                                    <div class="scfSingleLineGeneralPanel">
                                        <input id="telefonP" type="text" v-model="model.telefonP" maxlength="25" placeholder="Beispiel: +41 41 *** ** **" class="scfSingleLineTextBox">
                                    </div>
                                </div>

                                <div class="scfSingleLineTextBorder">
                                    <label for="telefonG" class="scfSingleLineTextLabel">
                                        {{ getTranslation('camp_edu_TelG') }}
                                    </label>
                                    <div class="scfSingleLineGeneralPanel">
                                        <input id="telefonG" type="text" v-model="model.telefonG" maxlength="25" placeholder="Beispiel: +41 41 *** ** **" class="scfSingleLineTextBox">
                                    </div>
                                </div>

                                <div class="scfSingleLineTextBorder">
                                    <label for="telefonM" class="scfSingleLineTextLabel">
                                        {{ getTranslation('camp_edu_TelM') }}
                                    </label>
                                    <div class="scfSingleLineGeneralPanel">
                                        <input id="telefonM" type="text" v-model="model.telefonM" maxlength="25" placeholder="Beispiel: +41 79 *** ** **"class="scfSingleLineTextBox">
                                    </div>
                                </div>

                                <div class="scfSingleLineTextBorder" v-if="model.showEmail1">
                                    <label for="email1" class="scfSingleLineTextLabel">
                                        {{ getTranslation('camp_edu_EMail1') }}
                                    </label>
                                    <div class="scfSingleLineGeneralPanel">
                                        <input id="email1" type="text" v-model="model.email1" maxlength="255" class="scfSingleLineTextBox">
                                    </div>
                                </div>

                                <div class="scfSingleLineTextBorder">
                                    <label for="email2" class="scfSingleLineTextLabel">
                                        {{ getTranslation('camp_edu_EMail2') }}
                                    </label>
                                    <div class="scfSingleLineGeneralPanel">
                                        <input id="email2" type="text" v-model="model.email2" maxlength="255" class="scfSingleLineTextBox">
                                    </div>
                                </div>

                                <div class="scfSingleLineTextBorder">
                                    <label for="email3" class="scfSingleLineTextLabel">
                                        {{ getTranslation('camp_edu_EMail3') }}
                                    </label>
                                    <div class="scfSingleLineGeneralPanel">
                                        <input id="email3" type="text" v-model="model.email3" maxlength="255" class="scfSingleLineTextBox">
                                    </div>
                                </div>

                            </div>
                        </fieldset>
                    </div>
                </div>

                <div class="scfFooterBorder">
                    <p></p>
                </div>

                <div class="scfSubmitButtonBorder">
                    <input type="submit" :value="getTranslation('camp_edu_Save')" @click.prevent="save" class="scfSubmitButton" />
                    <a href="../" class="button">{{ getTranslation('camp_Cancel') }}</a>
                </div>

            </div>
        </div>
    </section>
</template>
<script>
    import MyCampusStudMeineDaten from "../../../_Api/MyCampusStudMeineDaten";

    export default {
        data() {
            return {
                "model": {
                    "telefonP": null,
                    "telefonG": null,
                    "telefonM": null,
                    "showEmail1": false,
                    "email1": null,
                    "email2": null,
                    "email3": null,
                    "translations": null
                },
                "additional": {
                    "redirectUrl": null
                }
            }
        },
        created() {
            let data = this.$parent.$data;
            this.model = data.model;
            this.additional = data.additional;
        },
        methods: {
            save() {
                if (this.model.showEmail1
                    && !this.model.email1
                    && !this.model.email2
                    && !this.model.email3)
                {
                    this.showDialogOneRecommended();
                    return;
                }
                if (!this.model.showEmail1
                    && !this.model.email2
                    && !this.model.email3)
                {
                    this.showDialogOneRecommended();
                    return;
                }
                this.saveDo();
            },
            getTranslation(key) {
                return this.model.translations[key];
            },
            showDialogOneRecommended() {
                var thisSaveDo = this.saveDo;
                HSLU.dialog({
                    theme: 'red',
                    title: this.getTranslation('camp_edu_SaveWithoutEMailTitle'),
                    text: this.getTranslation('camp_edu_SaveWithoutEMailText'),
                    buttons: [
                        {
                            text: this.getTranslation('camp_edu_SaveWithoutEMailFalse'),
                            click: function () {
                                $(this).dialog("close");
                            }
                        },
                        {
                            text: this.getTranslation('camp_edu_SaveWithoutEMailTrue'),
                            click: function () {
                                $(this).dialog("close");
                                thisSaveDo();
                            }
                        }
                    ]
                });
            },
            saveDo() {
                var query = {
                    "telefonP": this.model.telefonP,
                    "telefonG": this.model.telefonG,
                    "telefonM": this.model.telefonM,
                    "email1": this.model.email1,
                    "email2": this.model.email2,
                    "email3": this.model.email3
                };
                MyCampusStudMeineDaten.updateCommunicationData(query, this.saveSuccess, this.saveFailure);
            },
            saveSuccess(data) {
                if (data.successful) {
                    window.location = this.additional.redirectUrl;
                }
                else {
                    dialogError(data.message);
                }
            },
            saveFailure(status) {
                dialogError("Es ist ein Fehler aufgetreten: Status-Code " + status);
            }
        }
    }
</script>
<style scoped>
</style>